import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-white" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', background: '#ffffff' }}>
      <Card className="w-full max-w-md mx-4 rounded-lg border border-[#e0e0e0] bg-white shadow-sm">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <div className="w-8 h-8 border border-[#e0e0e0] bg-white rounded-md flex items-center justify-center">
              <span className="text-[#1a1a1a] text-sm font-bold">CT</span>
            </div>
            <AlertCircle className="h-8 w-8 text-[#1a1a1a]" />
            <h1 className="text-2xl font-bold text-[#1a1a1a]">404 Page Not Found</h1>
          </div>

          <p className="mt-4 text-sm text-[#9b9b9b]">
            Did you forget to add the page to the router?
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
